/**
 * DEV-1859 (эпик DEV-1850). i18n раздела «Кампании».
 * Overlay-модуль: подмешивается deepMerge поверх базовых локалей.
 */
export const campaignsMessages = {
  ru: {
    common: {
      navigation: {
        campaigns: 'Кампании',
      },
    },
    campaigns: {
      title: 'Кампании',
      lead: 'Кампания — это цель и период, к которым привязаны размеченные ссылки. Метки source и medium берутся из справочника: telegram и Telegram — две разные строки в отчёте, поэтому значения выбираются, а не набираются руками.',
      noTarget: 'Цель не задана',
      targetSite: 'Основной сайт',
      targetArticle: 'Статья',
      targetCity: 'Город',
      targetCityGuide: 'Гид города',
      targetCityCatalog: 'Каталог города',
      targetComplex: 'Жилой комплекс',
      notFound: 'Кампания не найдена',
      note: 'Заметка',
      actions: {
        create: 'Новая кампания',
        newLink: 'Новая ссылка',
        archive: 'В архив',
        restore: 'Вернуть из архива',
        more: 'Действия с кампанией',
        dictionary: 'Справочник каналов',
      },
      columns: {
        campaign: 'Кампания',
        target: 'Цель',
        period: 'Период',
        links: 'Ссылок',
        stats: 'Просмотры · заявки · конв. за всё время',
        spend: 'Расход · CPL',
      },
      filters: {
        search: 'Поиск',
        searchPlaceholder: 'Название или слаг кампании',
        allTargets: 'Все цели',
        status: 'Статус',
        active: 'Активные',
        archived: 'В архиве',
        allStatuses: 'Все статусы',
      },
      empty: {
        title: 'Кампаний пока нет',
        description:
          'Заведите кампанию — и раздавайте ссылки на неё, а не собранные вручную адреса.',
      },
      period: {
        since: 'с {date}',
        until: 'до {date}',
      },
      stats: {
        views: 'Просмотры',
        leads: 'Заявки',
        conversion: 'Конверсия',
        cpl: 'Стоимость заявки',
        spend: 'расход {value}',
        noSpend: 'расход не задан',
        noViews: 'просмотров нет — конверсию не из чего считать',
        leadsExceedViews: 'заявок больше, чем просмотров: часть визитов маячок не записал',
        points: 'п. п.',
        vsMonth: 'к {month}',
        vsDays: 'к предыдущим {days} дн.',
        // Дательный падеж: Intl отдаёт «июль», а в подписи нужно «к июлю».
        monthsDative: {
          1: 'январю',
          2: 'февралю',
          3: 'марту',
          4: 'апрелю',
          5: 'маю',
          6: 'июню',
          7: 'июлю',
          8: 'августу',
          9: 'сентябрю',
          10: 'октябрю',
          11: 'ноябрю',
          12: 'декабрю',
        },
      },
      links: {
        title: 'Ссылки',
        hint: 'Адрес собирает сервер — в отчёте и здесь он один и тот же',
        channel: 'Канал',
        creative: 'Креатив',
        url: 'Адрес',
        shortUrl: 'Короткая',
        stats: 'Просмотры · заявки',
        qr: 'QR',
        copyShort: 'Скопировать короткий адрес',
        copyFull: 'Скопировать полный адрес',
        copyHint: 'Нажмите, чтобы скопировать',
        more: 'Действия со ссылкой',
        qrTitle: 'QR-код ссылки',
        empty: 'Ссылок пока нет. Первая же ссылка закрепит цель кампании.',
        confirmDelete: 'Удалить ссылку {url}? Она могла уже уйти в рекламу.',
      },
      link: {
        title: 'Новая ссылка',
        lead: 'Кампания «{campaign}» · ведёт на {target}',
        source: 'Источник (utm_source)',
        sourceHint: 'Из справочника: значения сверяются побайтово',
        sourcePlaceholder: 'Начните вводить: telegram, facebook…',
        medium: 'Канал (utm_medium)',
        mediumPlaceholder: 'Начните вводить: post, cpc…',
        dictionaryEmpty: 'Ничего не нашлось. Новое значение заводится в справочнике меток',
        campaign: 'Кампания (utm_campaign)',
        campaignHint: 'Слаг кампании; он уже в разосланных ссылках и не меняется',
        content: 'Креатив (utm_content)',
        contentPlaceholder: 'Например: hero-aug',
        contentHint: 'Необязательно. Различает варианты объявления',
        term: 'Ключевое слово (utm_term)',
        termHint: 'Необязательно. Для поисковых кампаний',
        result: 'Готовая ссылка',
        resultEmpty: 'Выберите источник и канал — ссылка соберётся сама',
        copy: 'Скопировать',
        copied: 'Скопировано',
        downloadQr: 'Скачать QR',
        withLogo: 'Со знаком VINPROP',
        submit: 'Сохранить ссылку',
        savedLead: 'Ссылка сохранена. Короткий адрес выдал сервер — он уже работает.',
        shortLabel: 'Короткий адрес',
        shortHint: 'Для постов, сторис и переписки: не рвётся переносом строки',
        shortMissing: 'Кода нет — ссылка заведена до сокращателя',
        fullLabel: 'Полный адрес',
        fullHint: 'Для рекламного кабинета: метки видны целиком',
        another: 'Создать ещё',
        done: 'Готово',
        noTarget: 'Сначала задайте цель кампании',
      },
      form: {
        createTitle: 'Новая кампания',
        editTitle: 'Кампания',
        lead: 'Слаг подставится из названия — он же станет utm_campaign в ссылках',
        name: 'Название',
        namePlaceholder: 'Например: Селавия · август',
        slug: 'Слаг',
        slugHint: 'Латиница, цифры, дефис. Менять после раздачи ссылок нельзя',
        slugLocked: 'Слаг уже уехал в ссылки — менять его нельзя',
        target: 'Цель',
        targetLanding: 'Площадка',
        targetSite: 'Главная сайта',
        targetArticle: 'Статья',
        targetCityGuide: 'Гид города',
        targetCityCatalog: 'Каталог города',
        targetComplex: 'Жилой комплекс',
        targetLocked: 'Цель уже используется в ссылках — менять её нельзя',
        city: 'Город',
        cityPlaceholder: 'Выберите город',
        cityGuideHint: 'Показаны города, у которых гид заполнен: пустой гид отдаётся без текста',
        cityCatalogHint: 'Подборка проектов города',
        article: 'Статья',
        complex: 'Жилой комплекс',
        pageLocale: 'Язык страницы',
        pageLocales: {
          ru: 'Русский',
          en: 'English',
          vn: 'Tiếng Việt',
        },
        articlePlaceholder: 'Найдите статью по названию',
        articleEmpty: 'Статьи не нашлись',
        complexPlaceholder: 'Начните вводить название ЖК',
        complexEmpty: 'Комплексы не нашлись',
        localeHint: 'Язык страницы, на которую поведёт ссылка',
        landing: 'Площадка',
        landingPlaceholder: 'Выберите площадку',
        locale: 'Локаль',
        locales: {
          ru: 'Русская — vinprop.vn/ru/',
          en: 'Английская — vinprop.vn/en/',
          vn: 'Вьетнамская — vinprop.vn/vn/',
        },
        period: 'Период',
        periodPlaceholder: 'Начало — окончание',
        spend: 'Расход, USD',
        spendPlaceholder: 'Например: 420',
        spendHint: 'Необязательно. Из него считается стоимость заявки',
        note: 'Заметка',
        notePlaceholder: 'Зачем кампания и что в ней решили',
        submit: 'Создать кампанию',
        errors: {
          titleRequired: 'Без названия кампанию не найти в списке',
          slugRequired: 'Слаг уедет в ссылки как utm_campaign',
          slugTaken: 'Такой слаг уже у другой кампании',
          landingRequired: 'Выберите площадку — на неё поведут ссылки',
          articleRequired: 'Выберите статью — на неё поведут ссылки',
          cityRequired: 'Выберите город — на него поведут ссылки',
          complexRequired: 'Выберите жилой комплекс — на него поведут ссылки',
          noPage: 'У этой страницы нет собственного адреса на сайте — выберите другую',
          cyrillic: 'Только латиница: кириллица в метке ломает отчёт',
          charset: 'Только латиница, цифры, точка и дефис',
          tooLong: 'Не длиннее {max} символов',
          spend: 'Число, не меньше нуля',
        },
      },
      dictionary: {
        title: 'Справочник каналов',
        lead: 'Значения меток сравниваются побайтово: telegram и Telegram дадут в отчёте две строки. Поэтому в ссылке их выбирают, а не набирают.',
        columns: {
          source: 'Источники (utm_source)',
          medium: 'Каналы (utm_medium)',
        },
        add: 'Добавить значение',
        remove: 'Удалить значение',
        valuePlaceholder: 'Значение метки, например telegram',
        titlePlaceholder: 'Подпись, например Telegram',
        done: 'Готово',
        errors: {
          duplicate: 'Такое значение уже есть',
        },
      },
    },
  },
  en: {
    common: {
      navigation: {
        campaigns: 'Campaigns',
      },
    },
    campaigns: {
      title: 'Campaigns',
      lead: 'A campaign is a target and a period that tagged links belong to. Source and medium values come from the dictionary: telegram and Telegram are two different rows in the report, so they are picked, not typed.',
      noTarget: 'No target set',
      targetSite: 'Main site',
      targetArticle: 'Article',
      targetCity: 'City',
      targetCityGuide: 'City guide',
      targetCityCatalog: 'City catalog',
      targetComplex: 'Residential complex',
      notFound: 'Campaign not found',
      note: 'Note',
      actions: {
        create: 'New campaign',
        newLink: 'New link',
        archive: 'Archive',
        restore: 'Restore',
        more: 'Campaign actions',
        dictionary: 'Channel reference',
      },
      columns: {
        campaign: 'Campaign',
        target: 'Target',
        period: 'Period',
        links: 'Links',
        stats: 'Views · leads · conv., all time',
        spend: 'Spend · CPL',
      },
      filters: {
        search: 'Search',
        searchPlaceholder: 'Campaign name or slug',
        allTargets: 'All targets',
        status: 'Status',
        active: 'Active',
        archived: 'Archived',
        allStatuses: 'All statuses',
      },
      empty: {
        title: 'No campaigns yet',
        description:
          'Create a campaign and share its links instead of addresses assembled by hand.',
      },
      period: {
        since: 'from {date}',
        until: 'until {date}',
      },
      stats: {
        views: 'Views',
        leads: 'Leads',
        conversion: 'Conversion',
        cpl: 'Cost per lead',
        spend: 'spend {value}',
        noSpend: 'spend not set',
        noViews: 'no views — nothing to divide by',
        leadsExceedViews: 'more leads than views: some visits were not recorded by the beacon',
        points: 'pp',
        vsMonth: 'vs {month}',
        vsDays: 'vs previous {days} days',
        monthsDative: {
          1: 'January',
          2: 'February',
          3: 'March',
          4: 'April',
          5: 'May',
          6: 'June',
          7: 'July',
          8: 'August',
          9: 'September',
          10: 'October',
          11: 'November',
          12: 'December',
        },
      },
      links: {
        title: 'Links',
        hint: 'The address is assembled by the server — it is the same here and in the report',
        channel: 'Channel',
        creative: 'Creative',
        url: 'Address',
        shortUrl: 'Short',
        stats: 'Views · leads',
        qr: 'QR',
        copyShort: 'Copy short address',
        copyFull: 'Copy full address',
        copyHint: 'Click to copy',
        more: 'Link actions',
        qrTitle: 'Link QR code',
        empty: 'No links yet. The first link locks the campaign target.',
        confirmDelete: 'Delete the link {url}? It may already be live in ads.',
      },
      link: {
        title: 'New link',
        lead: 'Campaign “{campaign}” · goes to {target}',
        source: 'Source (utm_source)',
        sourcePlaceholder: 'Start typing: telegram, facebook…',
        mediumPlaceholder: 'Start typing: post, cpc…',
        dictionaryEmpty: 'Nothing found. New values are added in the UTM dictionary',
        campaign: 'Campaign (utm_campaign)',
        campaignHint: 'Campaign slug; it is already in the links you handed out and cannot change',
        sourceHint: 'From the dictionary: values are compared byte by byte',
        medium: 'Medium (utm_medium)',
        content: 'Creative (utm_content)',
        contentPlaceholder: 'For example: hero-aug',
        contentHint: 'Optional. Tells ad variants apart',
        term: 'Keyword (utm_term)',
        termHint: 'Optional. For search campaigns',
        result: 'Ready link',
        resultEmpty: 'Pick a source and a medium — the link builds itself',
        copy: 'Copy',
        copied: 'Copied',
        downloadQr: 'Download QR',
        withLogo: 'With the VINPROP mark',
        submit: 'Save link',
        savedLead: 'Link saved. The short address comes from the server and already works.',
        shortLabel: 'Short address',
        shortHint: 'For posts, stories and chats: survives line wrapping',
        shortMissing: 'No code — this link predates the shortener',
        fullLabel: 'Full address',
        fullHint: 'For ad platforms: every tag is visible',
        another: 'Create another',
        done: 'Done',
        noTarget: 'Set the campaign target first',
      },
      form: {
        createTitle: 'New campaign',
        editTitle: 'Campaign',
        lead: 'The slug comes from the name — it becomes utm_campaign in links',
        name: 'Name',
        namePlaceholder: 'For example: Selavia · August',
        slug: 'Slug',
        slugHint: 'Latin letters, digits, hyphen. Cannot change once links are out',
        slugLocked: 'The slug is already in shared links and cannot change',
        target: 'Target',
        targetLanding: 'Landing',
        targetSite: 'Main site',
        targetArticle: 'Article',
        targetCityGuide: 'City guide',
        targetCityCatalog: 'City catalog',
        targetComplex: 'Residential complex',
        targetLocked: 'The target is already used by links and cannot change',
        city: 'City',
        cityPlaceholder: 'Pick a city',
        cityGuideHint: 'Only cities with a filled guide: an empty guide is served without text',
        cityCatalogHint: 'The city project listing',
        article: 'Article',
        complex: 'Residential complex',
        pageLocale: 'Page language',
        pageLocales: {
          ru: 'Русский',
          en: 'English',
          vn: 'Tiếng Việt',
        },
        articlePlaceholder: 'Find an article by title',
        articleEmpty: 'No articles found',
        complexPlaceholder: 'Start typing the complex name',
        complexEmpty: 'No complexes found',
        localeHint: 'Language of the page the link leads to',
        landing: 'Landing',
        landingPlaceholder: 'Pick a landing',
        locale: 'Locale',
        locales: {
          ru: 'Russian — vinprop.vn/ru/',
          en: 'English — vinprop.vn/en/',
          vn: 'Vietnamese — vinprop.vn/vn/',
        },
        period: 'Period',
        periodPlaceholder: 'Start — end',
        spend: 'Spend, USD',
        spendPlaceholder: 'For example: 420',
        spendHint: 'Optional. Cost per lead is calculated from it',
        note: 'Note',
        notePlaceholder: 'Why this campaign and what was decided',
        submit: 'Create campaign',
        errors: {
          titleRequired: 'Without a name the campaign is hard to find',
          slugRequired: 'The slug goes into links as utm_campaign',
          slugTaken: 'Another campaign already uses this slug',
          landingRequired: 'Pick a landing — links will lead there',
          articleRequired: 'Pick an article — links will lead there',
          cityRequired: 'Pick a city — links will lead there',
          complexRequired: 'Pick a residential complex — links will lead there',
          noPage: 'This page has no address of its own on the site — pick another one',
          cyrillic: 'Latin only: Cyrillic in a tag breaks the report',
          charset: 'Latin letters, digits, dot and hyphen only',
          tooLong: 'No longer than {max} characters',
          spend: 'A number, zero or more',
        },
      },
      dictionary: {
        title: 'Channel dictionary',
        lead: 'Tag values are compared byte by byte: telegram and Telegram give two rows in the report. That is why links pick them from a list.',
        columns: {
          source: 'Sources (utm_source)',
          medium: 'Mediums (utm_medium)',
        },
        add: 'Add value',
        remove: 'Remove value',
        valuePlaceholder: 'Tag value, e.g. telegram',
        titlePlaceholder: 'Caption, e.g. Telegram',
        done: 'Done',
        errors: {
          duplicate: 'This value already exists',
        },
      },
    },
  },
  vn: {
    common: {
      navigation: {
        campaigns: 'Chiến dịch',
      },
    },
    campaigns: {
      title: 'Chiến dịch',
      lead: 'Chiến dịch là đích đến và khoảng thời gian mà các liên kết gắn thẻ thuộc về. Giá trị source và medium lấy từ danh mục: telegram và Telegram là hai dòng khác nhau trong báo cáo, nên phải chọn chứ không gõ tay.',
      noTarget: 'Chưa đặt đích',
      targetSite: 'Trang chính',
      targetArticle: 'Bài viết',
      targetCity: 'Thành phố',
      targetCityGuide: 'Cẩm nang thành phố',
      targetCityCatalog: 'Danh mục thành phố',
      targetComplex: 'Khu phức hợp',
      notFound: 'Không tìm thấy chiến dịch',
      note: 'Ghi chú',
      actions: {
        create: 'Chiến dịch mới',
        newLink: 'Liên kết mới',
        archive: 'Lưu trữ',
        restore: 'Khôi phục',
        more: 'Thao tác với chiến dịch',
        dictionary: 'Danh mục kênh',
      },
      columns: {
        campaign: 'Chiến dịch',
        target: 'Đích đến',
        period: 'Thời gian',
        links: 'Liên kết',
        stats: 'Lượt xem · yêu cầu · CR, toàn thời gian',
        spend: 'Chi phí · CPL',
      },
      filters: {
        search: 'Tìm kiếm',
        searchPlaceholder: 'Tên hoặc slug chiến dịch',
        allTargets: 'Mọi đích đến',
        status: 'Trạng thái',
        active: 'Đang chạy',
        archived: 'Đã lưu trữ',
        allStatuses: 'Mọi trạng thái',
      },
      empty: {
        title: 'Chưa có chiến dịch',
        description: 'Tạo chiến dịch và chia sẻ liên kết của nó thay vì địa chỉ ghép tay.',
      },
      period: {
        since: 'từ {date}',
        until: 'đến {date}',
      },
      stats: {
        views: 'Lượt xem',
        leads: 'Yêu cầu',
        conversion: 'Chuyển đổi',
        cpl: 'Giá mỗi yêu cầu',
        spend: 'chi phí {value}',
        noSpend: 'chưa nhập chi phí',
        noViews: 'không có lượt xem — không có gì để chia',
        leadsExceedViews: 'yêu cầu nhiều hơn lượt xem: một phần lượt truy cập chưa được ghi nhận',
        points: 'điểm %',
        vsMonth: 'so với {month}',
        vsDays: 'so với {days} ngày trước',
        monthsDative: {
          1: 'tháng 1',
          2: 'tháng 2',
          3: 'tháng 3',
          4: 'tháng 4',
          5: 'tháng 5',
          6: 'tháng 6',
          7: 'tháng 7',
          8: 'tháng 8',
          9: 'tháng 9',
          10: 'tháng 10',
          11: 'tháng 11',
          12: 'tháng 12',
        },
      },
      links: {
        title: 'Liên kết',
        hint: 'Địa chỉ do máy chủ ghép — ở đây và trong báo cáo là một',
        channel: 'Kênh',
        creative: 'Mẫu quảng cáo',
        url: 'Địa chỉ',
        shortUrl: 'Rút gọn',
        stats: 'Lượt xem · yêu cầu',
        qr: 'QR',
        copyShort: 'Sao chép địa chỉ rút gọn',
        copyFull: 'Sao chép địa chỉ đầy đủ',
        copyHint: 'Bấm để sao chép',
        more: 'Thao tác với liên kết',
        qrTitle: 'Mã QR của liên kết',
        empty: 'Chưa có liên kết. Liên kết đầu tiên sẽ khoá đích của chiến dịch.',
        confirmDelete: 'Xoá liên kết {url}? Có thể nó đã chạy quảng cáo.',
      },
      link: {
        title: 'Liên kết mới',
        lead: 'Chiến dịch «{campaign}» · dẫn tới {target}',
        source: 'Nguồn (utm_source)',
        sourcePlaceholder: 'Nhập để tìm: telegram, facebook…',
        mediumPlaceholder: 'Nhập để tìm: post, cpc…',
        dictionaryEmpty: 'Không tìm thấy. Giá trị mới được thêm trong từ điển UTM',
        campaign: 'Chiến dịch (utm_campaign)',
        campaignHint: 'Slug chiến dịch; nó đã nằm trong các liên kết đã phát và không đổi',
        sourceHint: 'Từ danh mục: giá trị được so khớp từng ký tự',
        medium: 'Kênh (utm_medium)',
        content: 'Mẫu quảng cáo (utm_content)',
        contentPlaceholder: 'Ví dụ: hero-aug',
        contentHint: 'Không bắt buộc. Phân biệt các biến thể quảng cáo',
        term: 'Từ khoá (utm_term)',
        termHint: 'Không bắt buộc. Dành cho chiến dịch tìm kiếm',
        result: 'Liên kết hoàn chỉnh',
        resultEmpty: 'Chọn nguồn và kênh — liên kết sẽ tự ghép',
        copy: 'Sao chép',
        copied: 'Đã sao chép',
        downloadQr: 'Tải QR',
        withLogo: 'Có biểu tượng VINPROP',
        submit: 'Lưu liên kết',
        savedLead: 'Đã lưu liên kết. Địa chỉ rút gọn do máy chủ cấp và đã hoạt động.',
        shortLabel: 'Địa chỉ rút gọn',
        shortHint: 'Dùng cho bài đăng, story và tin nhắn: không bị ngắt dòng',
        shortMissing: 'Chưa có mã — liên kết tạo trước khi có rút gọn',
        fullLabel: 'Địa chỉ đầy đủ',
        fullHint: 'Dùng cho trình quản lý quảng cáo: thấy đủ các nhãn',
        another: 'Tạo thêm',
        done: 'Xong',
        noTarget: 'Hãy đặt đích của chiến dịch trước',
      },
      form: {
        createTitle: 'Chiến dịch mới',
        editTitle: 'Chiến dịch',
        lead: 'Slug lấy từ tên — nó sẽ thành utm_campaign trong liên kết',
        name: 'Tên',
        namePlaceholder: 'Ví dụ: Selavia · tháng 8',
        slug: 'Slug',
        slugHint: 'Chữ Latinh, số, dấu gạch ngang. Không đổi sau khi phát liên kết',
        slugLocked: 'Slug đã nằm trong liên kết đã phát — không đổi được',
        target: 'Đích đến',
        targetLanding: 'Trang đích',
        targetSite: 'Trang chính',
        targetArticle: 'Bài viết',
        targetCityGuide: 'Cẩm nang thành phố',
        targetCityCatalog: 'Danh mục thành phố',
        targetComplex: 'Khu phức hợp',
        targetLocked: 'Đích đã được liên kết sử dụng — không đổi được',
        city: 'Thành phố',
        cityPlaceholder: 'Chọn thành phố',
        cityGuideHint: 'Chỉ các thành phố đã có nội dung cẩm nang',
        cityCatalogHint: 'Danh sách dự án của thành phố',
        article: 'Bài viết',
        complex: 'Khu phức hợp',
        pageLocale: 'Ngôn ngữ trang',
        pageLocales: {
          ru: 'Русский',
          en: 'English',
          vn: 'Tiếng Việt',
        },
        articlePlaceholder: 'Tìm bài viết theo tiêu đề',
        articleEmpty: 'Không tìm thấy bài viết',
        complexPlaceholder: 'Nhập tên khu phức hợp',
        complexEmpty: 'Không tìm thấy khu phức hợp',
        localeHint: 'Ngôn ngữ của trang mà liên kết dẫn tới',
        landing: 'Trang đích',
        landingPlaceholder: 'Chọn trang đích',
        locale: 'Ngôn ngữ',
        locales: {
          ru: 'Tiếng Nga — vinprop.vn/ru/',
          en: 'Tiếng Anh — vinprop.vn/en/',
          vn: 'Tiếng Việt — vinprop.vn/vn/',
        },
        period: 'Thời gian',
        periodPlaceholder: 'Bắt đầu — kết thúc',
        spend: 'Chi phí, USD',
        spendPlaceholder: 'Ví dụ: 420',
        spendHint: 'Không bắt buộc. Dùng để tính giá mỗi yêu cầu',
        note: 'Ghi chú',
        notePlaceholder: 'Chiến dịch để làm gì và đã quyết định điều gì',
        submit: 'Tạo chiến dịch',
        errors: {
          titleRequired: 'Không có tên thì khó tìm chiến dịch',
          slugRequired: 'Slug sẽ vào liên kết dưới dạng utm_campaign',
          slugTaken: 'Slug này đã thuộc chiến dịch khác',
          landingRequired: 'Chọn trang đích — liên kết sẽ dẫn tới đó',
          articleRequired: 'Chọn bài viết — liên kết sẽ dẫn tới đó',
          cityRequired: 'Chọn thành phố — liên kết sẽ dẫn tới đó',
          complexRequired: 'Chọn khu phức hợp — liên kết sẽ dẫn tới đó',
          noPage: 'Trang này không có địa chỉ riêng trên website — hãy chọn trang khác',
          cyrillic: 'Chỉ chữ Latinh: chữ Kirin trong thẻ làm hỏng báo cáo',
          charset: 'Chỉ chữ Latinh, số, dấu chấm và gạch ngang',
          tooLong: 'Không dài quá {max} ký tự',
          spend: 'Là số, không nhỏ hơn 0',
        },
      },
      dictionary: {
        title: 'Danh mục kênh',
        lead: 'Giá trị thẻ được so khớp từng ký tự: telegram và Telegram sẽ thành hai dòng trong báo cáo. Vì vậy trong liên kết phải chọn chứ không gõ.',
        columns: {
          source: 'Nguồn (utm_source)',
          medium: 'Kênh (utm_medium)',
        },
        add: 'Thêm giá trị',
        remove: 'Xoá giá trị',
        valuePlaceholder: 'Giá trị thẻ, ví dụ telegram',
        titlePlaceholder: 'Nhãn, ví dụ Telegram',
        done: 'Xong',
        errors: {
          duplicate: 'Giá trị này đã có',
        },
      },
    },
  },
}
